import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { BrokerService } from './broker.service';

@Injectable()
export class LocationService extends BaseService {

  constructor(private broker: BrokerService) {
    super();
  }

  getSites(): Promise<Array<any>> {
    console.log('locations:getSites()');

    var request: any = {
      path: '/api/v1/locations/sites'
    };

    return this.broker.call(request);
  }

  getBuildings(siteId?: number): Promise<Array<any>> {
    console.log('locations:getBuildings()');

    var request: any = {
      path: '/api/v1/locations/buildings'
    };

    return this.broker.call(request);
  }

  getFloors(buildingId?: number): Promise<Array<any>> {
    console.log('locations:getFloors()');

    var request: any = {
      path: '/api/v1/locations/floors',
      queryString: { buildingId: buildingId }
    };

    return this.broker.call(request);
  }

  getRooms(floorId?: number): Promise<Array<any>> {
    console.log('locations:getRooms()');

    var request: any = {
      path: '/api/v1/locations/rooms',
      queryString: { floorId: floorId }
    };

    return this.broker.call(request);
  }

  getChildLocations(parentId: number): Promise<Array<any>> {
    console.log('locations:getChildLocations()');

    var request: any = {
      path: '/api/v1/locations',
      queryString: { parentId: parentId }
    };

    return this.broker.call(request);
  }

  getLocations(): Promise<Array<any>> {
    console.log('locations:getLocations()');

    var request: any = {
      path: '/api/v1/locations'
    };

    return this.broker.call(request);
  }

}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/services/location.service.ts